import { Action } from '@ngrx/store';
import {
  DeviceConfiguration,
  OrganizationSettings,
} from '@secure/devices/store/models/device-configuration.model';
import { DeviceBasicDetails } from '../models/devices.model';

export enum ActionTypes {
  SET_CONIG_BY_DEVICE_ID = 'SET_CONFIG_DEVICE_BY_ID',
  SET_LOCALLY_CHANGED_FIELD = 'SET_LOCALLY_CHANGED_FIELD',
  SET_VPN_SERVER_CHANGED_FLAG = 'SET_VPN_SERVER_CHANGED_FLAG',
  SET_CONFIGURATION_VERSION = 'SET_CONFIGURATION_VERSION',
  SET_VERSION_CHANGED = 'SET_VERSION_CHANGED',
  SET_DEVICE_BASIC_DETAILS = 'SET_DEVICE_BASIC_DETAILS',
  SET_ACTIVE_NET_SUB_SERVICE = 'SET_ACTIVE_NET_SUB_SERVICE',
  SET_ACTIVE_TS_SUB_SERVICE = 'SET_ACTIVE_TS_SUB_SERVICE',
  SET_ACTIVE_TS_SETTINGS_SUB_SERVICE = 'SET_ACTIVE_TS_SETTINGS_SUB_SERVICE',
  SET_ACTIVE_VPN_SUB_SERVICE = 'SET_ACTIVE_VPN_SUB_SERVICE',
  SET_ACTIVE_SURICATA_SUB_SERVICE = 'SET_ACTIVE_SURICATA_SUB_SERVICE',
  SET_ORGANIZATION_SETTINGS = 'SET_ORGANIZATION_SETTINGS',
  SET_ACTIVE_ROUTING_SUB_SERVICE = 'SET_ACTIVE_ROUTING_SUB_SERVICE',
  SET_ACTIVE_DYNAMIC_ROUTING_SUB_SERVICE = 'SET_ACTIVE_DYNAMIC_ROUTING_SUB_SERVICE',
  SET_ACTIVE_DNS_SUB_SERVICE = 'SET_ACTIVE_DNS_SUB_SERVICE',
}
export class SetDeviceConfigurationById implements Action {
  readonly type = ActionTypes.SET_CONIG_BY_DEVICE_ID;
  constructor(public payload: DeviceConfiguration) {}
}

export class SetLocallyChangedField implements Action {
  readonly type = ActionTypes.SET_LOCALLY_CHANGED_FIELD;
  constructor(public payload: boolean) {}
}

export class SetVpnServerChangedFlag implements Action {
  readonly type = ActionTypes.SET_VPN_SERVER_CHANGED_FLAG;
  constructor(public payload: boolean) {}
}

export class SetDeviceVersion implements Action {
  readonly type = ActionTypes.SET_CONFIGURATION_VERSION;
  constructor(public payload: number) {}
}

export class SetVersionChanged implements Action {
  readonly type = ActionTypes.SET_VERSION_CHANGED;
  constructor(public payload: boolean) {}
}

export class SetDeviceBasicDetails implements Action {
  constructor(public payload: DeviceBasicDetails) {}
  readonly type = ActionTypes.SET_DEVICE_BASIC_DETAILS;
}

export class SetActiveNetSubService implements Action {
  constructor(public payload: string) {}
  readonly type = ActionTypes.SET_ACTIVE_NET_SUB_SERVICE;
}

export class SetActiveTsSubService implements Action {
  constructor(public payload: string) {}
  readonly type = ActionTypes.SET_ACTIVE_TS_SUB_SERVICE;
}

export class SetActiveTsSettingsSubService implements Action {
  constructor(public payload: string) {}
  readonly type = ActionTypes.SET_ACTIVE_TS_SETTINGS_SUB_SERVICE;
}

export class SetActiveVPNSubService implements Action {
  constructor(public payload: string) {}
  readonly type = ActionTypes.SET_ACTIVE_VPN_SUB_SERVICE;
}

export class SetActiveSuricataSubService implements Action {
  constructor(public payload: string) {}
  readonly type = ActionTypes.SET_ACTIVE_SURICATA_SUB_SERVICE;
}

export class SetActiveRoutingSubService implements Action {
  constructor(public payload: string) {}
  readonly type = ActionTypes.SET_ACTIVE_ROUTING_SUB_SERVICE;
}

export class SetActiveDynamicRoutingSubService implements Action {
  constructor(public payload: string) {}
  readonly type = ActionTypes.SET_ACTIVE_DYNAMIC_ROUTING_SUB_SERVICE;
}

export class SetActiveDnsSubService implements Action {
  constructor(public payload: string) {}
  readonly type = ActionTypes.SET_ACTIVE_DNS_SUB_SERVICE;
}

export class SetOrganizationSettings implements Action {
  constructor(public payload: OrganizationSettings) {}
  readonly type = ActionTypes.SET_ORGANIZATION_SETTINGS;
}

export type Actions =
  | SetDeviceConfigurationById
  | SetLocallyChangedField
  | SetVpnServerChangedFlag
  | SetDeviceVersion
  | SetVersionChanged
  | SetDeviceBasicDetails
  | SetActiveNetSubService
  | SetActiveTsSubService
  | SetActiveTsSettingsSubService
  | SetActiveVPNSubService
  | SetActiveSuricataSubService
  | SetActiveRoutingSubService
  | SetActiveDynamicRoutingSubService
  | SetActiveDnsSubService
  | SetOrganizationSettings;
